// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuPopupMenu{--vuu-icon-height:20px;--vuu-icon-left:2px;--vuu-icon-size:var(--vuuPopupMenu-iconSize,16px);--vuu-icon-width:16px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
